module.exports = __webpack_public_path__ + "img/2.eaf4f5bf.png";